// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2bWF1","error":"Textarea_error__Mk3bh","readonly":"Textarea_readonly__IB21B","disabled":"Textarea_disabled__1QDXg"};